export enum VerificationStatus {
	REQUESTED = 'REQUESTED',
	VERIFIED = 'VERIFIED',
	NONVERIFIED = 'NON-VERIFIED'
}

export interface OrganizationItem {
	id: string;
	name: string;
	companyName: string;
	verificationStatus: VerificationStatus;
	profileColor: string;
	initials: string;
}
